var CryptoJS = require("crypto-js")

export async function encrypt(payload) {
    const encData = await CryptoJS.AES.encrypt(
        JSON.stringify(payload),
        "hello1234"
    ).toString()
    return encData
}

export async function decrypt(payload) {
    let decryptedPayload = await CryptoJS.AES.decrypt(
        payload,
        "hello1234"
    ).toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedPayload);

}

